module.exports = __webpack_public_path__ + "static/media/valor1.81eb7bbd.png";